import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { INDUSTRIES } from "../data/content";

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-24 md:py-32 bg-white/50 border-y border-jo-primary/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <SectionHeader
          center
          label="Industries We Serve"
          title="Trusted across every sector"
          desc="From healthcare to fintech, we power operations for organizations of every size and stage."
        />

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Building2;
            return (
              <Reveal key={ind.name} delay={i * 0.04}>
                <motion.div
                  data-testid={`industry-${i}`}
                  whileHover={{ y: -6 }}
                  className="group flex items-center gap-3.5 rounded-2xl bg-white border border-jo-primary/8 px-5 py-4 hover:border-jo-accent hover:shadow-lg hover:shadow-jo-primary/5 transition-[border,box-shadow,transform] duration-300"
                >
                  <span className="h-11 w-11 rounded-xl bg-jo-primary/5 flex items-center justify-center shrink-0 group-hover:bg-jo-highlight group-hover:text-white transition-colors duration-300 text-jo-primary">
                    <Icon size={20} strokeWidth={1.75} />
                  </span>
                  <span className="text-sm font-semibold text-jo-primary leading-tight">
                    {ind.name}
                  </span>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
